import React, {useEffect, useState} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import Booking from './components/Booking';
import Confirmation from './components/Confirmation';
import Terms from './components/Terms';
import ReactModal from 'react-modal';
import axios from 'axios';
import './assets/css/notice.css';
import apiRequest from './handles/apiRequest';

const backupHTML = `
<h3><strong>Note</strong></h3>
<p>The safety of our customers and staff is our utmost priority.</p>
<p>All staff at our branches are fully vaccinated, and we hope you are
 too, in the spirit of #kitajagakita.</p>
<p> Before you visit our branch, please ensure that you:</p>
<ul>
    <li>Do <strong>NOT</strong> have any Covid-19 symptoms</li>
    <li><strong>ARE</strong> categorised under "Low Risk" in the MySejahtera
     profile</li>
    <li>Have <strong>NOT</strong> come into close contact with someone who is
     Covid-19 positive</li>
</ul>
<p>If you do not meet any of the above, kindly reschedule your appointment. For
a safer & more convenient option, please use our M2U web, M2U MY app or
MAE app.</p>
<p>We appreciate your understanding on this matter. Thank you.</p>
`;

const App = () => {
  // States
  const [showModal, setShowModal] = useState(false);
  const [note, setNote] = useState('');

  // Updates.
  useEffect(() => {
    global['dataLayer'].push({
      event: 'gaEvent',
      eventCategory: 'Online Form',
      eventLabel: 'EzyQ New Appointment',
      eventAction: 'Landing',
    });

    // Get service info
    apiRequest({
      method: 'GET',
      endpoint: 'noticeFlag',
    }).then(({noticeFlag= 0, noticeUrl = ''}) => {
      // Show or hide notice
      if (noticeFlag && noticeUrl) {
        setShowModal(true);

        // Get services
        axios({
          method: 'GET',
          url: noticeUrl,
        }).then(({data = ''}) => {
          if (data) {
            setNote(data);
          }
        }).catch(() => {
          setNote(backupHTML);
        });
      }
    });
  }, []);

  return (
    <BrowserRouter>
      <div>
        <Switch>
          <Route path="/page/appointment/" component={Booking} exact/>
          <Route path="/page/appointment/confirm" component={Confirmation}/>
          <Route path="/page/appointment/terms" component={Terms}/>
        </Switch>
      </div>
      <ReactModal
        class={'test'}
        appElement={document.getElementById('root')}
        isOpen={showModal}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          },
          content: {
            position: 'relative',
            background: 'transparent',
            border: 'none',
            inset: '50% auto auto auto',
            margin: '0 auto',
            padding: 0,
            width: '100%',
            transform: 'translateY(-50%)',
            maxHeight: '90%',
          },
        }}
      >
        <div
          className={'col-md-offset-3 col-lg-offset-3 col-sm-offset-2' +
          ' col-md-6 col-lg-6 col-sm-8 col-xs-offset-1 col-xs-10 popup'
          }>
          <p dangerouslySetInnerHTML={{__html: note}}/>
          <input type="submit" value="PROCEED" className="btnLogin"
            onClick={() => {
              setShowModal(false);
            }}/>
        </div>
      </ReactModal>
    </BrowserRouter>
  );
};

export default App;
